/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedSearchSuggestions_itemSearch = {
    readonly pageType: string | null;
    readonly searchCorrections: {
        readonly suggestions: ReadonlyArray<{
            readonly name: string | null;
            readonly uri: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "SbSharedSearchSuggestions_itemSearch";
};
export type SbSharedSearchSuggestions_itemSearch$data = SbSharedSearchSuggestions_itemSearch;
export type SbSharedSearchSuggestions_itemSearch$key = {
    readonly " $data"?: SbSharedSearchSuggestions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedSearchSuggestions_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedSearchSuggestions_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "kind": "LinkedField",
      "name": "searchCorrections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchCorrectionSuggestionsValues",
          "kind": "LinkedField",
          "name": "suggestions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uri",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'f8fd0aeee9c1231e9ec4431fcc26fec8';
export default node;
